import * as React from 'react';

import * as styles from '../../../Styles/svgShadow.css';

const IconPlay = () => (
    <svg viewBox="0 0 100 100" className={styles.svgShadow}>
        <polygon points="58.332,23.282 67.498,23.282 67.498,77.857 58.332,77.857"/>
        <polygon points="32.502,23.282 41.668,23.282 41.668,77.857 32.502,77.857"/>
    </svg>
);

export default IconPlay;